module.exports = __webpack_public_path__ + "img/dq_pic_summary.cd219b11.png";